<template>
	<div>
		<Header :isHome="false"></Header>
		
		<div style="padding-top: 6rem;">
			<div class="container">
					<div style="font-size: 1rem;font-weight: 500;margin-top: 1rem;cursor: pointer;">
						<span @click="tohome()" class="hover-light">Home</span> > <span @click="touserlevel()" class="hover-light">My membership</span> > Membership records
					</div>
					<div class="r-title" style="margin-top: 2rem;">
						<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
						<span style="z-index: 1;position: relative;">Membership records</span>
					</div>
					
					<!-- 记录列表 -->
					<div style="margin-top: 1rem;margin-bottom: 3rem;">
						<div v-for="(item, index) in data" :key="index" style="border: 1px solid #eee;border-radius: 0.5rem;background-color: #fff;padding: 1rem;margin-bottom: 1rem;" v-if="item.order">
							<div style="font-size: 0.8rem;margin-bottom: 1rem;width: 100%;color: #666">
								Order number: {{item.order.PI}}
							</div>
							
							<div style="width: 100%;padding-top: 1rem;border-top: 1px solid #eee;display: flex;justify-content: space-between;">
								<div style="display: flex;">
									<div style="margin-right: 1rem;">
										<img src="../../assets/imgs/user/userlevel/userrecord-icon.png" style="width: 4rem;">
									</div>
									<div>
										<div style="font-size: 1.2rem;font-weight: bold;margin-bottom: 0.5rem;">
											{{item.order.title}} plan
										</div>
										<div style="font-size: 0.7rem;">
											Payment time: {{item.order.receiveTime*1000|format}}
										</div>
									</div>
								</div>
								<div style="font-size: 1.2rem;font-weight: bold;">
									${{item.order.amount}}
								</div>
							</div>
						</div>
						
						<!-- 空状态 -->
						<div v-show="data.length==0&&loading" class="nodata-box">
							<img src="../../assets/imgs/nodata.svg" class="nodata-img">
						</div>
					</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	
				import Header from '/src/components/header.vue'
				import Footer from '/src/components/footer.vue'
				export default {
					data() {
						return {
							data: [],
							loading:false
						}
					},
					props:{
					},
					components: {
						Header,
						Footer
					},
					filters: {
					},
					methods: {
						getdata(){
								this.request({
									method: 'get',
									url: '/gci/user/vip/list',
								}).then(res => {
									this.data = res.data.items
									this.$bus.$emit('loading', false)
									this.loading=true
								}).catch(error => {
									console.error(error.response)
								})
						},
						getuserinfo(){
							this.request({
								method: 'get',
								url: '/gci/user/info',
							}).then(res => {
								this.providerinfo = res.data.provider
							}).catch(error => {
								console.error(error.response)
							})
						},
						tohome(){
							this.$router.push({name:'home'})
						},
						touserlevel(){
							this.$router.push({name:'userlevel'})
						}
					},
					created() {
						this.$bus.$emit('loading', true)
					},
					mounted() {
						this.getdata()
						if(localStorage.getItem('token')){
							// this.getuserinfo()
						}
					}
				}
</script>

<style scoped lang="scss">
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
</style>